export { default, type ServicesContentProps } from './ServicesContent';
